module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_WhiteOL-b960013b172e0883ca8fd67db28ad42d.png";